import { selectLanguage } from "redux/reducers/languageReducer";

const { useSelector } = require("react-redux");
const { selectSearchData } = require("redux/reducers/searchReducer");

const useFindLocation = () => {
  const allData = useSelector(selectSearchData);
  const language = useSelector(selectLanguage);

  const jsonToString = (json) => {
    const obj = JSON.parse(json);
    const values = Object.values(obj);
    const string = values.join("").replaceAll("<br />", "");
    return string;
  };

  // const searchData = allData.map((data) => {
  //   return { text: jsonToString(data.text[language]), location: data.url };
  // });

  // const findLocation = (word) => {
  //   const locations = [];
  //   searchData.forEach((data) => {
  //     if (data.text.match(word, "i")) locations.push(data.location);
  //   });
  //   return locations;
  // };
  // return findLocation;
};

export default useFindLocation;
